<template>
  <div class="login-credentials">
    <div class="auth-toggle">
      <button
        :class="['toggle-btn', { active: tab !== 'register' }]"
        v-on:click="$parent.modalSetTab('login')"
      >
        Log In
      </button>
      <button
        :class="['toggle-btn', { active: tab === 'register' }]"
        v-on:click="$parent.modalSetTab('register')"
      >
        Sign Up
      </button>
    </div>
    <div v-if="tab === 'register'" class="credentials-element">
      <div class="credentials-element">
        <div class="element-title">USERNAME</div>
        <div class="element-input">
          <input v-model="loginUsername" type="text" placeholder="Username" />
        </div>
      </div>
    </div>

    <div class="credentials-element">
      <div class="element-title">EMAIL</div>
      <div class="element-input">
        <input v-model="loginEmail" type="text" placeholder="Email" />
      </div>
    </div>
    <div class="credentials-element">
      <div class="element-title">PASSWORD</div>
      <div class="element-input">
        <input v-model="loginPassword" type="password" placeholder="Password" />
      </div>
    </div>
    <button
      v-if="tab === 'login'"
      v-on:click="$parent.modalSetTab('forgot')"
      class="button-forgot"
    >
      <div class="button-inner">
        <span>Forgot your password?</span>
      </div>
    </button>

    <div v-if="tab === 'register'" class="credentials-element">
      <div class="element-title">PASSWORD CONFIRM</div>
      <div class="element-input">
        <input
          v-model="loginPasswordConfirm"
          type="password"
          placeholder="Confirm password"
        />
      </div>
    </div>
    <div class="credentials-info">
      By accessing 99wiwi.com, I attest that I am at least 18 years old and have
      read and agree with the
      <button v-on:click="loginTermsButton()" class="button-terms">
        Terms of Service</button
      >.
    </div>
    <div class="credentials-buttons">
      <button
        v-on:click="loginActionButton()"
        class="button-action"
        v-bind:disabled="authSendLoginLoading === true"
      >
        <div class="button-inner">{{ tab }}</div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LoginCredentials",
  props: ["tab"],
  data() {
    return {
      loginUsername: null,
      loginEmail: null,
      loginPassword: null,
      loginPasswordConfirm: null,
    };
  },
  methods: {
    ...mapActions([
      "modalsSetShow",
      "modalsSetData",
      "notificationShow",
      "authSendCredentialsLogin",
      "authSendCredentialsRegister",
    ]),

    loginActionButton() {
      if (this.loginEmail === null || this.loginEmail.trim() === "") {
        this.notificationShow({
          type: "error",
          message: "Your entered email is invalid.",
        });
        return;
      }

      if (this.loginPassword === null || this.loginPassword.trim() === "") {
        this.notificationShow({
          type: "error",
          message: "Your entered password is invalid.",
        });
        return;
      }

      if (this.tab === "register") {
        if (this.loginPassword !== this.loginPasswordConfirm) {
          this.notificationShow({
            type: "error",
            message: "Your entered passwords do not match.",
          });
          return;
        }

        this.notificationShow({
          type: "success",
          message: "All inputs look valid. Creating your account...",
        });

        this.authSendCredentialsRegister({
          username: this.loginUsername,
          email: this.loginEmail,
          password: this.loginPassword,
        });
      } else {
        this.notificationShow({
          type: "success",
          message: "Inputs look valid. Signing you in...",
        });

        this.authSendCredentialsLogin({
          username: this.loginUsername,
          email: this.loginEmail,
          password: this.loginPassword,
        });
      }
    },

    loginTermsButton() {
      this.modalsSetShow(null);
      setTimeout(() => {
        this.modalsSetShow("Terms");
      }, 300);
    },
  },
  computed: {
    ...mapGetters(["authSendLoginLoading"]),
  },
};
</script>

<style scoped>
.auth-toggle {
  display: flex;
  background: #1c1c1e; /* dark background */
  border-radius: 9999px; /* pill shape */
  padding: 4px;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20px;
}

.toggle-btn {
  flex: 1;
  padding: 10px 0;
  border: none;
  background: transparent;
  color: #8e8e93; /* gray inactive */
  font-size: 0.825rem;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
}

.toggle-btn.active {
  background: #e6d58e; /* gold background */
  color: #000;
}
.login-credentials {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-credentials .credentials-element {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5px;
}

.login-credentials .credentials-element:first-child {
  margin-top: 0;
}

.login-credentials .element-title {
  font-size: 14px;
  font-weight: 800;
  color: #bbbfd0;
  display: none;
}

.login-credentials .element-input {
  width: 100%;
  height: 2.75rem;
  position: relative;
  margin-top: 10px;
  padding: 1px;
  border-radius: 0.75rem;
  overflow: hidden;
  border: 2px solid rgb(44 44 49);
  background: rgb(41 41 46);
}

.login-credentials .element-input::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}

.login-credentials .element-input input {
  width: 100%;
  height: 100%;
  padding: 0 177px 0 25px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background-color: transparent;
}

.login-credentials .element-input input::placeholder {
  color: rgb(121 121 134);
}

.login-credentials button.button-forgot {
  transition: all 0.2s;
  width: 100%;
}
.login-credentials button.button-forgot:hover {
  transition-duration: 0.2s;
  opacity: 0.8;
}
.login-credentials button.button-forgot:active {
  transition-duration: 0.2s;
}

.login-credentials button.button-forgot::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #1a4f63;
  z-index: -1;
  display: none;
}

.login-credentials button.button-forgot::after {
  content: "";
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  position: absolute;
  top: 1px;
  left: 1px;
  background-color: #07243a;
  clip-path: polygon(
    11px 0,
    calc(100% - 11px) 0,
    100% 25%,
    100% 75%,
    calc(100% - 11px) 100%,
    11px 100%,
    0 75%,
    0 25%
  );
  z-index: -1;
  display: none;
}

.login-credentials button.button-forgot .button-inner {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: end;
  margin-top: 5px;
}

.login-credentials button.button-forgot .button-inner span {
  font-size: 0.85rem;
  font-weight: 500;
  color: rgb(203 190 137);
}

.login-credentials button.button-forgot .button-inner svg {
  width: 17px;
  height: 17px;
  display: none;
  fill: #bbbfd0;
}

.login-credentials .credentials-info {
  width: 100%;
  margin-top: 35px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: rgb(121 121 134);
}

.login-credentials .credentials-info button.button-terms {
  text-decoration: underline;
  font-size: 14px;
  font-weight: 700;
  color: rgb(203 190 137);
}

.login-credentials .credentials-buttons {
  display: flex;
  align-items: center;
  margin-top: 35px;
  width: 100%;
}

.login-credentials button.button-toggle {
  width: 200px;
  height: 54px;
  position: relative;
  margin-right: 20px;
  padding: 1px;
  z-index: 1;
  transition: all 0.2s;
}

.login-credentials button.button-action {
  width: 100%;
  position: relative;
}

.button-action:hover {
  transition-duration: 0.1s;
  transform: translateY(-1px);
  opacity: 0.8;
}
.button-action:active {
  transition-duration: 0.2s;
  transform: translateY(2px);
}

.login-credentials button.button-toggle .button-inner,
.login-credentials button.button-action .button-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}

.login-credentials button.button-toggle .button-inner {
  color: #bbbfd0;
  background-color: #1a4f63;
}

.login-credentials button.button-toggle.button-active .button-inner {
  color: #00ffc2;
  background: radial-gradient(
      60% 60% at 50% 50%,
      rgba(0, 255, 194, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    linear-gradient(
      255deg,
      rgba(0, 255, 194, 0.05) 0%,
      rgba(0, 170, 109, 0.05) 100%
    );
}

.login-credentials button.button-action .button-inner {
  border: 2px solid rgb(19 87 77);
  background-color: rgb(15 80 70);
  color: rgb(255 255 255);
  padding: 0.825rem;
  border-radius: 9999px;
  text-transform: capitalize;
}

@media only screen and (max-width: 430px) {
  .login-credentials .element-input input {
    padding: 0 62px 0 25px;
  }

  .login-credentials .credentials-buttons {
    width: 100%;
    flex-direction: column;
  }

  .login-credentials button.button-toggle,
  .login-credentials button.button-action {
    width: 100%;
    transition: all;
    transition-duration: 0.2s;
  }

  .button-action:hover {
    opacity: 0.8;
  }
  .button-action:focus {
    scale: 0.95;
  }

  .login-credentials button.button-toggle {
    margin-bottom: 10px;
    margin-right: 0;
  }
}
</style>
